<template>
  <button 
    class="base-button"
    :class="{ 
      'variant-outline': variant === 'outline',
      'variant-solid': variant === 'solid'
    }"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

defineProps<{
  variant?: 'outline' | 'solid'
}>()

defineEmits(['click'])
</script>

<script lang="ts">
export default {
  name: 'BaseButton'
}
</script>

<style scoped>
.base-button {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: none;
}

.variant-outline {
  background: transparent;
  border: 2px solid var(--colour-red-text-colour);
  color: var(--colour-icons);
}

.variant-outline:hover {
  background: var(--bg-hover);
}

.variant-solid {
  background: var(--colour-red-text-colour);
  border: none;
  color: var(--colour-icons);
}

.variant-solid:hover {
  background: var(--colour-red-text-colour);
}
</style>
